import { Badge, BadgeSize, Icon, IconSize, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import type { RulebookMeterChip } from "@next-platform/packages-ts-types";
import React, { memo, useMemo } from "react";

import { resolveMeterIcon } from "@/components/Rulebook/meterIcons";
import { useMeterColor } from "@/hooks";

import { meterTextTint } from "../RulebookEditor/utils/meterPalette";

type RulebookMeterChipBadgeProps = {
  chip: RulebookMeterChip;
  index: number;
  "data-testid"?: string;
};

const RulebookMeterChipBadge = ({ chip, index, "data-testid": testId = "RulebookMeterChipBadge" }: RulebookMeterChipBadgeProps) => {
  const meterColor = useMeterColor(chip.color);
  const iconStyle = useMemo(() => (meterColor ? { color: meterColor } : undefined), [meterColor]);
  const iconClassName = meterColor ? "" : meterTextTint(index);
  const icon = resolveMeterIcon({ icon: chip.icon, meterType: chip.type });

  return (
    <Badge
      showDot={false}
      size={BadgeSize.SMALL}
      className="inline-flex h-[22px] gap-1 rounded-[6px] bg-gray-4 px-2 text-gray-11"
      data-testid={testId}
    >
      <span className={iconClassName} style={iconStyle} data-testid="RulebookMeterChipBadge-Icon">
        <Icon icon={icon} size={IconSize.XSMALL} />
      </span>
      <Text as="span" variant={TextVariants.LABEL_SMALL_REGULAR}>
        {chip.label}
      </Text>
    </Badge>
  );
};

export default memo(RulebookMeterChipBadge);
